import { Fragment, memo, useState } from "react";
import { Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import popup_box from "../../Assets/Images/landingpages-webp/popup_box.webp";

interface TermsBlock {
  title: string;
  items?: string[];
}

const TERMS_BLOCKS: TermsBlock[] = [
  { title: "Subscribe & Win Contest" },
  { title: "Reward:" },
  {
    title: "Rs. 10,000 Monthly",
    items: [
      "1 winner will be selected through a lucky draw for Rs. 10,000 cash prize every month.",
    ],
  },
  {
    title: "Winner Announcement:",
    items: [
      "Winner will be selected randomly from all eligible entries.",
      "The organizers’ decision regarding the selection of the winner is final and binding.",
      "The winner will be notified via Call and SMS within 72 hours of the winning date",
      "The winner name will also be announced on our service's Instagram and Facebook accounts.",
    ],
  },
  {
    title: "Terms and Conditions:",
    items: [
      "To claim prizes, the user must have been successfully charged at least once a month.",
      "The user will be chosen from the list of subscribers of the existing month.",
      "We reserve the right/discretion to set/change the price/rate of any offer or withdraw from the Subscribe & Win contest at any time.",
      "By participating in the lucky draw, winner grant the organizers the right to use their names, photos, and related information for promotional purposes.",
      "The winner must be a citizen of Pakistan and he/she has a Jazz cash account associated with the winning number.",
      "Prizes are non-transferable and cannot be exchanged for cash or other alternatives.",
      "The organizers reserve the right to substitute a prize with another of equal or higher value if necessary.",
      "Employees, affiliates, and immediate family members of the organizing company are not eligible to participate.",
      "The organizers’ decision is final and no correspondence or complaints will be entertained.",
      "Winner needs to provide a photograph that will be used for marketing and media purposes and the Organizers have the right to use these images without seeking prior approval of the prize winner.",
      "The organizers reserve the right to amend or change these terms and conditions at their discretion.",
      "If for any reason the competition does not run for its entire duration due to a computer virus, tampering, unauthorized intervention, fraud, technical failures or any other cause beyond the reasonable control of the Organizers, the Organizers then reserve the right in its sole discretion, to (a) disqualify any entrant or (b) modify, suspend, terminate or cancel the promotion, as appropriate.",
      "No user can claim the reward or Mobile data more than mentioned or announced or decided by organizers.",
    ],
  },
  {
    title: "Limitation of Liability:",
    items: [
      "The organizers are not responsible for any loss, damage, or injury resulting from participation in the lucky draw or the use of prizes.",
      "Participants agree to release the organizers from any liability associated with the lucky draw and cannot claim anything through a legal case for damages.",
    ],
  },
  {
    title: "Disqualification:",
    items: [
      "If the call center contacts the users and they don't respond within 24 hours, they would be disqualified.",
      "The organizers reserve the right to disqualify participants who violate the terms and conditions or engage in fraudulent activities.",
      "The organizers reserve the right to modify, suspend, or terminate the lucky draw at any time without prior notice.",
    ],
  },
];

/** Reused congratulatory body shared by the static and React modals. */
const LuckyDrawBody = ({ onTerms }: { onTerms?: () => void }) => (
  <div className="modal-body">
    <div className="congrats">Congratulations</div>
    <div className="sub-title">
      You have entered in our
      <div className="s-title">Lucky Draw</div>
      FOR
    </div>
    <div className="title">Subscribe and Win</div>
    <div className="sub-title">
      Winner will be announced via Social Media/Customer Support
    </div>
    <button
      data-toggle="modal"
      data-target="#termNconditionsPopup"
      data-dismiss="modal"
      onClick={onTerms}
    >
      Terms and Conditions
    </button>
  </div>
);

interface LuckyDrawModalsProps {
  show: boolean;
  onClose: () => void;
}

const LuckyDrawModals = ({ show, onClose }: LuckyDrawModalsProps) => {
  const [showTerms, setShowTerms] = useState(false);
  const openTerms = () => setShowTerms(true);
  const closeTerms = () => setShowTerms(false);

  return (
    <>
      {/* Static (Bootstrap-controlled) subscribe-and-win popup */}
      <div
        className="modal fade showSubscribePopup"
        id="showSubscribePopup"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="showSubscribePopupLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content subNwin-modal">
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <div className="main-image">
              <img src={popup_box} alt="subscribe and win" />
            </div>
            <LuckyDrawBody />
          </div>
        </div>
      </div>

      {/* React subscribe-and-win modal */}
      <Modal show={show} onHide={onClose} centered>
        <Modal.Body>
          <div className="main-image">
            <img src={popup_box} alt="subscribe and win" />
          </div>
          <span className="closePopButton" onClick={onClose}>
            <FontAwesomeIcon icon={solid("circle-xmark")} />
          </span>
          <LuckyDrawBody
            onTerms={() => {
              onClose();
              openTerms();
            }}
          />
        </Modal.Body>
      </Modal>

      {/* Terms & conditions modal */}
      <Modal
        show={showTerms}
        onHide={closeTerms}
        centered
        className="termNcondition-modal"
      >
        <Modal.Header>
          <div className="modal-header">
            <span className="closePopButton2" onClick={closeTerms}>
              <FontAwesomeIcon icon={solid("circle-xmark")} />
            </span>
            <h5 className="modal-title" id="termNconditionsPopupLabel">
              Terms &amp; Conditions
            </h5>
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="modal-body">
            <div className="tnc">
              {TERMS_BLOCKS.map((block) => (
                <Fragment key={block.title}>
                  <div className="tc-title">{block.title}</div>
                  {block.items && (
                    <ul>
                      {block.items.map((item) => (
                        <li key={item}>{item}</li>
                      ))}
                    </ul>
                  )}
                </Fragment>
              ))}
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default memo(LuckyDrawModals);
